import React from 'react';
import {makeStyles} from '@material-ui/styles';
import {
    Box,
    CardHeader,
    CardContent,
    Divider,
    Grid,
    Card
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(2),
        backgroundColor: theme.palette.background.default
    }
}));

const Color = () => {
    const classes = useStyles();

    return (
        <Card className={classes.root}>
            <CardHeader
                title="Color"
            />
            <Divider/>
            <CardContent>
                <Grid
                    container
                    spacing={1}
                >
                    <Grid item xs={12} sm={6}>
                        <Box bgcolor="common.black" color="common.white" p={2}>
                            common.black
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Box bgcolor="common.white" color="common.black" p={2}>
                            common.white
                        </Box>
                    </Grid>
                </Grid>

                <Grid
                    container
                    spacing={1}
                >
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="gray.main" color="gray.contrastText" p={2}>
                            gray.main
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="gray.light" color="gray.contrastText" p={2}>
                            gray.light
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="gray.dark" color="gray.contrastText" p={2}>
                            gray.dark
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="gray.contrastText" color="gray.main" p={2}>
                            gray.contrastText
                        </Box>
                    </Grid>
                </Grid>

                <Grid
                    container
                    spacing={1}
                >
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="primary.main" color="primary.contrastText" p={2}>
                            primary.main
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="primary.light" color="primary.contrastText" p={2}>
                            primary.light
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="primary.dark" color="primary.contrastText" p={2}>
                            primary.dark
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="primary.contrastText" color="primary.main" p={2}>
                            primary.contrastText
                        </Box>
                    </Grid>
                </Grid>

                <Grid
                    container
                    spacing={1}
                >
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="secondary.main" color="secondary.contrastText" p={2}>
                            secondary.main
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="secondary.light" color="secondary.contrastText" p={2}>
                            secondary.light
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="secondary.dark" color="secondary.contrastText" p={2}>
                            secondary.dark
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="secondary.contrastText" color="secondary.main" p={2}>
                            secondary.contrastText
                        </Box>
                    </Grid>
                </Grid>

                <Grid
                    container
                    spacing={1}
                >
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="error.main" color="error.contrastText" p={2}>
                            error.main
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="error.light" color="error.contrastText" p={2}>
                            error.light
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="error.dark" color="error.contrastText" p={2}>
                            error.dark
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="error.contrastText" color="error.main" p={2}>
                            error.contrastText
                        </Box>
                    </Grid>
                </Grid>

                <Grid
                    container
                    spacing={1}
                >
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="warning.main" color="warning.contrastText" p={2}>
                            warning.main
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="warning.light" color="warning.contrastText" p={2}>
                            warning.light
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="warning.dark" color="warning.contrastText" p={2}>
                            warning.dark
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="warning.contrastText" color="warning.main" p={2}>
                            warning.contrastText
                        </Box>
                    </Grid>
                </Grid>

                <Grid
                    container
                    spacing={1}
                >
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="info.main" color="info.contrastText" p={2}>
                            info.main
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="info.light" color="info.contrastText" p={2}>
                            info.light
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="info.dark" color="info.contrastText" p={2}>
                            info.dark
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="info.contrastText" color="info.main" p={2}>
                            info.contrastText
                        </Box>
                    </Grid>
                </Grid>

                <Grid
                    container
                    spacing={1}
                >
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="success.main" color="success.contrastText" p={2}>
                            success.main
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="success.light" color="success.contrastText" p={2}>
                            success.light
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="success.dark" color="success.contrastText" p={2}>
                            success.dark
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="success.contrastText" color="success.main" p={2}>
                            success.contrastText
                        </Box>
                    </Grid>
                </Grid>

                <Grid
                    container
                    spacing={1}
                >
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="text.primary" color="background.paper" p={2}>
                            text.primary
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="text.secondary" color="background.paper" p={2}>
                            text.secondary
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="text.disabled" color="background.paper" p={2}>
                            text.disabled
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="text.hint" color="background.paper" p={2}>
                            text.hint
                        </Box>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

export default Color;
